export const problems = [
  { code: 1, label: "1、喜欢长时间自身旋转。"},
  { code: 2, label: "2、学会做一件简单的事，但很快就忘记。"},
  { code: 3, label: "3、经常没有接触环境或进行交往的要求。" },
  { code: 4, label: "4、往往不能接受简单的指令(如坐下、来这儿等)。" },
  { code: 5, label: "5、不会玩玩具等(如没完没了地转动或乱扔、揉等)。" },
  { code: 6, label: "6、视觉辨别能力差(如对一种物体的特征——大小、颜色或位置等的辨别能力差）。" },
  { code: 7, label: "7、无交往性微笑(无社交性微笑,即不会与人点头、招呼、微笑)。" },
  { code: 8, label: "8、代词运用的颠倒或混乱(如反“你”说成“我”等等)。" },
  { code: 9, label: "9、长时间的总拿着某件东西。"},
  { code: 10, label: "10、似乎不在听人说话,以致怀疑他/她有听力问题。" },
  { code: 11, label: "11、说话无抑扬顿挫、无节奏。" },
  { code: 12, label: "12、长时间的摇摆身体。" },
  { code: 13, label: "13、要去拿什么东西,但又不是身体所能达到的地方(即对自身与物体距离估计不足)。" },
  { code: 14, label: "14、对环境和日常生活规律的改变产生强烈反应。"},
  { code: 15, label: "15、当他和其他人在一起时,对呼唤他的名字无反应。" },
  { code: 16, label: "16、经常做出前冲、脚尖行走、手指轻掐轻弹等动作。" },
  { code: 17, label: "17、对其他人的面部表情或情感没有反应。"},
  { code: 18, label: "18、说话时很少用“是”或“我”等词。" },
  { code: 19, label: "19、有某一方面的特殊能力,似乎与智力低下不相符合。" },
  { code: 20, label: "20、不能执行简单的含有介词的指令(如把球放在盒子上或把球放在盒子里)。" },
  { code: 21, label: "21、有时对很大的声音不产生吃惊的反应(可能让人想到儿童是聋子)。" },
  { code: 22, label: "22、经常拍打手。" },
  { code: 23, label: "23、发大脾气或经常发点脾气。" },
  { code: 24, label: "24、主动回避与别人进行眼光接触。" },
  { code: 25, label: "25、拒绝别人接触或拥抱。" },
  { code: 26, label: "26、有时对很痛苦的刺激(如摔伤、割破或注射不引起反应)。" },
  { code: 27, label: "27、身体表现很僵硬很难抱住(如打挺)。" },
  { code: 28, label: "28、当抱着他时,感到他肌肉松弛(即他不紧贴着抱他的人)。"},
  { code: 29, label: "29、以姿势、手势表示所渴望得到的东西(而不倾向用语言表示)。" },
  { code: 30, label: "30、常用脚尖走路。" },
  { code: 31, label: "31、用咬人、撞人、踢人等来伤害他人。" },
  { code: 32, label: "32、不断地重复短句。" },
  { code: 33, label: "33、游戏时不模仿其他儿童。" },
  { code: 34, label: "34、当强光直接照射眼睛时常常不眨眼。" },
  { code: 35, label: "35、以撞头、咬手等行为来自伤。" },
  { code: 36, label: "36、想要什么东西不能等待(一想要什么就马上要得到什么)。" },
  { code: 37, label: "37、不能指出5个以上物体的名称。" },
  { code: 38, label: "38、不能发展任何友谊(不会和小朋友来往交朋友)。" },
  { code: 39, label: "39、有许多声音的时候常常盖着耳朵。" },
  { code: 40, label: "40、经常旋转碰撞物体。" },
  { code: 41, label: "41、在训练大小便方面有困难(不会控制在小便)。" },
  { code: 42, label: "42、一天只能提出5个以内的要求。" },
  { code: 43, label: "43、经常受到惊吓或非常焦虑、不安。" },
  { code: 44, label: "44、在正常光线下斜眼、闭眼、皱眉。" },
  { code: 45, label: "45、不是经常帮助的话,不会自己给自己穿衣。" },
  { code: 46, label: "46、一遍一遍重复一些声音或词。" },
  { code: 47, label: "47、瞪着眼看人,好象要“看穿”似的。" },
  { code: 48, label: "48、重复别人的问话和回答。" },
  { code: 49, label: "49、经常不能意识所处的环境,并且可能对危险情况不在意。" },
  { code: 50, label: "50、特别喜欢摆弄并着迷于单调的东西或游戏、活动等(如来回的走或跑、没完没了地蹦、跳、拍敲)。" },
  { code: 51, label: "51、对周围东西喜欢触摸、嗅和/或尝。" },
  { code: 52, label: "52、对生人常无视觉反应(对来人不看)。" },
  { code: 53, label: "53、纠缠在一些复杂的仪式行为上,就像缠在魔圈子内(如走路一定要走一定的路线,饭前或睡前或干什么以前一定要把什么东西摆在什么样地方或做什么动作,否则就不睡,不吃等)。" },
  { code: 54, label: "54、经常毁坏东西(如玩具、家里的一切用具很快就弄破了)。" },
  { code: 55, label: "55、在二岁半以前就发现该儿童发育延迟。" },
  { code: 56, label: "56、在日常生活中至今仅会用15个但又不超过30个短句来进行交往。" },
  { code: 57, label: "57、长期凝视一个地方(呆呆地看一处)。" },
]

export const  defaultValues = {
  value1: "",
  value2: "",
  value3: "",
  value4: "",
  value5: "",
  value6: "",
  value7: "",
  value8: "",
  value9: "",
  value10: "",
  value11: "",
  value12: "",
  value13: "",
  value14: "",
  value15: "",
  value16: "",
  value17: "",
  value18: "",
  value19: "",
  value20: "",
  value21: "",
  value22: "",
  value23: "",
  value24: "",
  value25: "",
  value26: "",
  value27: "",
  value28: "",
  value29: "",
  value30: "",
  value31: "",
  value32: "",
  value33: "",
  value34: "",
  value35: "",
  value36: "",
  value37: "",
  value38: "",
  value39: "",
  value40: "",
  value41: "",
  value42: "",
  value43: "",
  value44: "",
  value45: "",
  value46: "",
  value47: "",
  value48: "",
  value49: "",
  value50: "",
  value51: "",
  value52: "",
  value53: "",
  value54: "",
  value55: "",
  value56: "",
  value57: "",
}

export const answers=[
  {code: 1, value: "是"},
  {code: 2, value: "否"},
]

